import { IMAGE_CONSTRAINTS, MIME_TO_EXTENSION } from '../constants/profilePhotoConstants';
export const validateImageFile = (file) => {
    if (!isValidImageType(file)) {
        return 'Please select a valid image file (JPEG, PNG, WebP, or GIF).';
    }
    if (isFileTooLarge(file)) {
        return `Image size must be less than ${IMAGE_CONSTRAINTS.MAX_SIZE_MB}MB.`;
    }
    return null;
};
const isValidImageType = (file) => {
    return file.type.startsWith('image/');
};
const isFileTooLarge = (file) => {
    return file.size > IMAGE_CONSTRAINTS.MAX_SIZE_BYTES;
};
export const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => {
            reject(new Error('Failed to read file'));
        };
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                resolve(result);
            }
            else {
                reject(new Error('Failed to read file as data URL'));
            }
        };
        reader.readAsDataURL(file);
    });
};
export const dataURLtoFile = (dataUrl, fileName = 'profile.jpg') => {
    const parts = dataUrl.split(',');
    const metadata = parts[0] || '';
    const base64Data = parts[1] || '';
    const mimeType = extractMimeType(metadata);
    const binaryData = atob(base64Data);
    const byteArray = createByteArray(binaryData);
    const extension = getFileExtension(mimeType);
    const buffer = byteArray.buffer;
    return new File([buffer], `profile.${extension}`, { type: mimeType });
};
const extractMimeType = (metadata) => {
    const match = metadata.match(/:(.*?);/);
    return (match === null || match === void 0 ? void 0 : match[1]) || 'image/jpeg';
};
const createByteArray = (binaryString) => {
    const length = binaryString.length;
    const arrayBuffer = new ArrayBuffer(length);
    const bytes = new Uint8Array(arrayBuffer);
    for (let i = 0; i < length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
};
const getFileExtension = (mimeType) => {
    return MIME_TO_EXTENSION[mimeType] || 'jpg';
};
export const getImageValidationResult = (file) => {
    const error = validateImageFile(file);
    return {
        isValid: error === null,
        error,
    };
};
export const parseExpiryMinutes = (message) => {
    if (!message)
        return null;
    const match = message.match(/(\d+)\s*minutes?/i);
    if (!match)
        return null;
    const minutes = Number(match[1]);
    return Number.isFinite(minutes) ? minutes : null;
};
export const isCacheValid = (cache, bufferMs) => {
    if (!(cache === null || cache === void 0 ? void 0 : cache.url))
        return false;
    return Date.now() + bufferMs < cache.expiresAtMs;
};
